<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设为客户弹框
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="client-build"
    width="600px"
    title="编辑客户"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div v-loading="loading" style="width: 440px; height: 350px; margin: 0px auto 20px">
      <el-form
        ref="postForm"
        v-loading="posting"
        class="mt-lg"
        label-position="left"
        label-width="100px"
        :model="formData"
        :rules="rules"
      >
        <el-form-item label="用户">
          <div class="flex align-items-center">
            <f-user-avatar :src="row.avatar" shape="rounded" />
            <span class="ml-sm">{{ row.nickname }}</span>
          </div>
        </el-form-item>
        <el-form-item label="客户类型">
          <el-radio-group>
            <el-radio>单位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户名称" required>
          <el-select v-model="formData.credit_code" ref="selectRef" popper-append-to-body placeholder="请选择" clearable filterable style="width: 100%;" @change="handleSelect" :filter-method="filterQuery" @clear="clearSelect">
            <el-option v-for="item in list" :key="item.credit_code" :label="item.company_name" :value="item.credit_code">
              <div class="flex align-items-center">
                <span class="bd">{{ item.company_name }}</span>
                <span class="ft ml-sm text-muted">{{ item.type == 1 ? '客户' : (item.type == 2 ? '线索' : '公司')  }}</span>
              </div>
            </el-option>

            <el-option
              v-if="list.length === 0 && keyword && !showSearchMore"
              disabled
              value="EMPTY_TIP"
              style="height:0;overflow:hidden;padding:0;border:none;" />

            <div v-if="keyword && !showSearchMore " v-loading="searching" role="button" class="flex align-items-center search-more"  @click="handleSearch" style="padding: 0 20px;">
              <span>搜索更多公司：</span>
              <span class="text-blue">{{ keyword }}</span>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.company_id && formData.company_id != '请选择'" label="客户等级" required>
          <el-rate v-model="formData.customer_level" @change="rateChange"></el-rate>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="flex-center mb">
      <el-button class="extend" @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :disabled="(!formData.company_id || !formData.customer_level)" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { customerPostApi } from '@/api/up/upMemberApi'
import { leadListApi, companyQueryApi, companyCreateApi } from '@/api/prm/prmApi'

export default {
  name: 'ClientBuild',

  components: {
    SearchContent: () => import("@/views/prm/components/SearchContent.vue"),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    row: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      loading: false,

      formData: {
        company_id: null,
        credit_code: null,
        customer_level: null,
      },

      rules: {
        credit_code: [{ required: true, message: '请选择客户', trigger: 'blur' }],
        customer_level: [{ required: true, message: '请选择客户等级', trigger: 'blur' }],
      },

      posting: false,
      clues: [],

      keyword: '',
      showSearchMore: false,
      searching: false,
      searchList: [],
      companyList: [],

      list: []
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    this.fetchLead()
    this.formData.company_id = this.row.company_id || null
    this.formData.customer_level = this.row.customer_level || null
    this.formData.credit_code = this.row.credit_code || null
  },

  methods: {
    rateChange(val) {
      this.formData.customer_level = val
    },

    filterQuery(e) {
      // console.log('filterQuery', e)
      if (e) {
        this.showSearchMore = false
      }
      this.keyword = e
      this.list = this.keyword ? (this.clues.concat(this.searchList)).filter(item => {
        const name = item.company_name || ''
        return name.indexOf(this.keyword) > -1
      }) : this.clues.concat(this.searchList)
    },

    handleSearch() {
      this.searching = true;
      companyQueryApi({ keyword: this.keyword }).then(res => {
        this.searching = false
        this.showSearchMore = true
        if (!res.errno) {
          const exists = new Set(this.clues.map(item => item.credit_code))
          this.companyList = res.data.filter(item => !exists.has(item.creditCode))
          if (this.companyList.length == 0) {
            this.$message.error('没有更多公司了')
            return
          }
          this.searchList = this.companyList.map(item => {
            return {
              company_name: item.name,
              credit_code: item.creditCode
            }
          })
          this.list = this.keyword ? (this.clues.concat(this.searchList)).filter(item => {
            const name = item.company_name || ''
            return name.indexOf(this.keyword) > -1
          }) : this.clues.concat(this.searchList)
        }
      })
    },

    clearSelect() {
      this.formData.company_id = null
      this.formData.customer_level = null
      this.formData.credit_code = null
      this.keyword = ''
    },

    handleSelect(item) {
      // console.log('handleSelect', item)
      if (!item) {
        return
      }
      if (this.companyList.find(company => company.creditCode == item)) {
        const temp = this.companyList.find(company => company.creditCode == item)
        companyCreateApi(temp).then(res => {
          if (!res.errno) {
            this.formData.company_id = res.data.company_id
            this.formData.customer_level = null
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        const currentCompany = this.clues.find(company => company.credit_code == item)
        this.formData.company_id = currentCompany.company_id
        this.formData.customer_level = currentCompany.customer_level || null
      }
    },

    fetchLead() {
      leadListApi().then(res => {
        if (!res.errno) {
          this.clues = res.data.list
          this.list = this.clues.concat(this.searchList)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    submit() {
      const temp = {
        memberid: this.row.memberid,
        company_id: this.formData.company_id,
        customer_level: this.formData.customer_level
      };
      this.$refs.postForm.validate((valid) => {
        if (valid) {
          this.posting = true
          customerPostApi(temp).then((res) => {
            this.posting = false
            if (!res.errno) {
              this.$message.success("客户设置成功！");
              this.$emit("success");
              this.dialogShow = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 30px 20px;
}
/deep/ .el-rate {
  height: 30px;
}
/deep/ .el-rate__icon {
  font-size: 20px;
  line-height: 30px;
}
/deep/ .el-select-dropdown__wrap {
  margin-bottom: 40px !important;
}
/deep/ .search-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e4e7ed;
  z-index: 999;
}
.search-more {
  padding: 0 20px;
  height: 34px;
}
.search-more:hover {
  background: #f5f7fa;
}
</style>
